module.exports = __webpack_public_path__ + "img/VECs-Cumulative.56726762.svg";